module.exports = __webpack_public_path__ + "img/corrugatedBox9.67b96517.jpg";